import { EPeriod } from "@domains/features/Markets/Futures/entities/Driving Market/iTopGainersLosers";
import { SET_PARAMS, } from "../../interface/DrivingMarket/iDrivingMarketParams";
export const initCommonState = {
    limit: true,
    period: EPeriod.ONE_DAY,
};
const drivingMarketParamsReducer = (state = initCommonState, action) => {
    switch (action.type) {
        case SET_PARAMS:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return Object.assign({}, state);
    }
};
export default drivingMarketParamsReducer;
